import { FC, ChangeEvent, ReactNode } from 'react'

type CheckboxChangeHandler = (event: ChangeEvent<HTMLInputElement>) => void

const Checkbox: FC<{
  onChange: CheckboxChangeHandler
  checked: boolean
  isIndeterminate?: boolean
  children?: ReactNode
}> = ({ onChange, checked, isIndeterminate = false, children }) => {
  return (
    <div className="relative flex items-start">
      <div className="flex h-6 items-center">
        <input
          id="offers"
          aria-describedby="offers-description"
          name="offers"
          type="checkbox"
          className="h-4 w-4 rounded border-gray-300 focus:ring-indigo-600 cursor-pointer"
          checked={checked}
          onChange={onChange}
          // Set the indeterminate attribute based on the isIndeterminate flag
          ref={(el) => {
            if (el) el.indeterminate = isIndeterminate || false
          }}
        />
      </div>
      <div className="ml-2 text-xs leading-6 w-full">
        <div className="font-medium">{children}</div>
      </div>
    </div>
  )
}

export default Checkbox
